import { deserialize, serializable } from 'serializr';
import { Base } from './base.model';
import { PageObject } from './page-object.model';

export class RuntimeVariable extends Base implements PageObject {
  @serializable
  public name: string;

  @serializable
  public applicationVersionId: number;

  @serializable
  public usageCount: number;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(RuntimeVariable, input));
  }
}
